import Vue from 'vue'
import App from './App.vue'
import router from './router'

// styles
import './assets/style/main.scss'

// components
import PageHeading from './components/PageHeading.vue'
Vue.component('PageHeading', PageHeading)

// i18n
import zh from './locale/zh'
import en from './locale/en'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

let lang = localStorage.getItem('lang')
if (!['zh', 'en'].includes(lang)) {
  lang = 'zh'
}

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'zh',
  availableLocales: ['zh', 'en'],
  messages: {
    zh,
    en
  }
})

const getLocaleValue = (object, rawKey) => {
  let value
  let key
  if (i18n.locale === 'en') {
    key = rawKey + 'En'
  }
  value = object[key] || object[rawKey]
  return value
}
Vue.prototype.$getLocaleValue = getLocaleValue

// axios
import axios from './axios'
Vue.prototype.$axios = axios

// event bus
const eventBus = new Vue({})
Vue.prototype.$eventBus = eventBus

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  i18n
  // vue.config.js 配置了 PrerenderSPAPlugin 需要以下代码：
  // mounted() {
  //   document.dispatchEvent(new Event('render-event'))
  // }
}).$mount('#app')
